module.exports = '4.12.1';



// WEBPACK FOOTER //
// ./src/version.js